/* eslint-disable @typescript-eslint/no-var-requires */
import Constants from 'expo-constants';

if (Constants.expoConfig.extra.storybookEnabled) {
  const Storybook = require('./.storybook-native').default;
  const registerRootComponent = require('expo').registerRootComponent;
  registerRootComponent(Storybook);
} else {
  require('expo-router/entry');
}
